import { jsxs, jsx } from 'react/jsx-runtime';
import { multiMonthViewHeader } from '../../datePicker.vanilla.mjs';
import { FormatWithLinearLocale } from '../../utils/format.mjs';
import CalendarHeader from './CalendarHeader.mjs';

const DEFAULT_MONTH_LABEL_FORMAT = {
  en: "MM yyyy",
  ko: "yyyy\uB144 M\uC6D4"
};
function MonthViewHeader({
  monthDate,
  increaseMonth,
  decreaseMonth,
  monthLabelFormat
}) {
  return /* @__PURE__ */ jsxs(CalendarHeader, { children: [
    /* @__PURE__ */ jsx(CalendarHeader.DateText, { children: /* @__PURE__ */ jsx(
      FormatWithLinearLocale,
      {
        date: monthDate,
        formatMap: monthLabelFormat ?? DEFAULT_MONTH_LABEL_FORMAT
      }
    ) }),
    /* @__PURE__ */ jsxs(CalendarHeader.RightSlot, { children: [
      /* @__PURE__ */ jsx(CalendarHeader.PrevIconButton, { onClick: decreaseMonth }),
      /* @__PURE__ */ jsx(CalendarHeader.NextIconButton, { onClick: increaseMonth })
    ] })
  ] });
}
function MultiMonthViewHeader({
  monthDate,
  increaseMonth,
  decreaseMonth,
  monthLabelFormat,
  customHeaderCount,
  monthsShown
}) {
  return /* @__PURE__ */ jsxs(CalendarHeader, { justify: "center", className: multiMonthViewHeader, children: [
    customHeaderCount === 0 && /* @__PURE__ */ jsx(CalendarHeader.LeftSlot, { children: /* @__PURE__ */ jsx(
      CalendarHeader.PrevIconButton,
      {
        onClick: decreaseMonth,
        css: { position: "absolute", left: 0 }
      }
    ) }),
    /* @__PURE__ */ jsx(CalendarHeader.DateText, { children: /* @__PURE__ */ jsx(
      FormatWithLinearLocale,
      {
        date: monthDate,
        formatMap: monthLabelFormat ?? DEFAULT_MONTH_LABEL_FORMAT
      }
    ) }),
    customHeaderCount === monthsShown - 1 && /* @__PURE__ */ jsx(CalendarHeader.RightSlot, { children: /* @__PURE__ */ jsx(
      CalendarHeader.NextIconButton,
      {
        onClick: increaseMonth,
        css: { position: "absolute", right: 0 }
      }
    ) })
  ] });
}

export { MonthViewHeader, MultiMonthViewHeader };
//# sourceMappingURL=month.mjs.map
